import { Injectable } from '@angular/core';
import { Http, RequestOptions, Headers } from '@angular/http';
import { ReportModel } from '../classes/ReportModel';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { GroupModel } from "../classes/GroupModel";
import { Adal4Service } from "adal-angular4";
import { TokenService } from "./token.service";

@Injectable()
export class GroupsService {

  private headers;
  options;
  selectedGroup: GroupModel;
  listaGroups: GroupModel[];
  token: any;
  
  constructor(private AdalService: Adal4Service, private _httpService: Http, private tokenService: TokenService) { 
    
    this.token = this.AdalService.userInfo.token;    
    this.headers = new Headers({'content-Type': 'application/json'});
    this.headers.append('authorization',`bearer ${this.token}`)    

  }

  getGroupById(groupId: number): Promise<GroupModel> {
    let url = `/api/Groups/${groupId}`;
    this.tokenService.handleTokenExpiration();  
    return this._httpService.get(url, { headers: this.headers })
      .toPromise()
      .then(groups => groups.json() as GroupModel)
      .catch(this.handleError);
  }

  getGroups(): Promise<GroupModel[]> {
    let url = "/api/getallgruoups";
    this.tokenService.handleTokenExpiration();  
    return this._httpService.get(url, { headers: this.headers })
      .toPromise()
      .then(groups => groups.json())
      .catch(this.handleError);
  }   

   private handleError(error: any): Promise<any> {
    console.error('DEU ERRO!', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }
}


// WEBPACK FOOTER //
// C:/Users/ewerton.w.da.silva/Documents/Visual Studio 2017/Projects/SCL_Valia/SCL_Valia/src/app/shared/services/groups.service.ts